import '../scss/base.scss';

// Bootstrap 5 is jQuery-free. jQuery used to be imported and exposed globally
// here (window.$, window.jQuery), forcing it into every page's boot path. It is
// gone now: modules that still need jQuery get it via webpack's ProvidePlugin,
// and no front-end inline script relies on the global. This keeps public pages
// jQuery-free at load time.
import * as bootstrap from 'bootstrap';

// --- DOM ready helper (no jQuery) -------------------------------------------
function onReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

// --- Bootstrap components ----------------------------------------------------
onReady(function () {
  // Enable popovers
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (el) {
    return new bootstrap.Popover(el);
  });
  // Auto-show server-rendered toasts
  document.querySelectorAll('.bootstrap-toast').forEach(function (el) {
    new bootstrap.Toast(el).show();
  });
});

// --- Delegated UI handlers (event delegation on document) -------------------

// Nav link active state
document.addEventListener('click', function (e) {
  const link = e.target.closest('.nav-link');
  if (!link) return;
  if (link.classList.contains('active')) return;
  const nav = link.closest('.nav');
  if (nav) {
    nav.querySelectorAll('.nav-link').forEach(function (l) {
      l.classList.remove('active');
    });
  }
  link.classList.add('active');
});

// Static (client-side) pagination
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.static-pagination button[data-action-pagination]');
  if (!btn) return;
  const block = btn.closest('.static-pagination');
  const nextBtn = block.querySelector('button[data-action-pagination=next]');
  const prevBtn = block.querySelector('button[data-action-pagination=previous]');
  const nbPage = block.querySelectorAll('div[data-page]').length;
  const page = parseInt(block.dataset.currentPage, 10);
  // Only two buttons supported (next / previous).
  const nextPage = btn.dataset.actionPagination === 'next' ? page + 1 : page - 1;

  const current = block.querySelector('[data-page="' + page + '"]');
  const target = block.querySelector('[data-page="' + nextPage + '"]');
  if (current) current.style.display = 'none';
  if (target) target.style.display = '';

  const cls = 'background-activ-travaux';
  if (nextPage >= nbPage) {
    nextBtn.classList.remove(cls);
    prevBtn.classList.add(cls);
    nextBtn.disabled = true;
    prevBtn.disabled = false;
  } else if (nextPage <= 1) {
    prevBtn.classList.remove(cls);
    nextBtn.classList.add(cls);
    prevBtn.disabled = true;
    nextBtn.disabled = false;
  } else {
    nextBtn.disabled = false;
    prevBtn.disabled = false;
  }
  block.dataset.currentPage = nextPage;
});

// Rotate collapse chevron 180deg
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('[data-bs-toggle=collapse]');
  if (!toggle) return;
  const img = toggle.querySelector('img');
  if (img) img.classList.toggle('rotate-180');
});

// Bot-hidden links: base64-encoded target in data-atc
document.addEventListener('click', function (e) {
  const span = e.target.closest('span[data-atc]');
  if (!span) return;
  const url = atob(span.dataset.atc);
  if (span.getAttribute('target') === '_blank') {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
});

// Horizontal slider pagination
function horizontalScroll(el, prev) {
  const blockSlider = el.closest('.block-slider');
  if (!blockSlider) return;
  const sliderContent = blockSlider.querySelector('div.slider .slider-content');
  if (!sliderContent) return;
  const item = sliderContent.querySelector('.slider-item');
  let distance = item ? item.offsetWidth : 0;
  if (prev) distance = -distance;
  sliderContent.scrollBy({ left: distance, behavior: 'smooth' });
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('div.button-pagination button');
  if (!btn) return;
  let previous = true;
  if (btn.dataset.actionPagination === 'next') {
    document.querySelectorAll('button[data-action-pagination=previous]').forEach(function (b) {
      b.removeAttribute('disabled');
    });
    previous = false;
  }
  horizontalScroll(btn, previous);
});

// --- Toasts API -------------------------------------------------------------
window.showToast = function (message, tag) {
  if (tag === 'error') tag = 'danger';
  if (!tag) tag = 'info';

  const toastHtml =
    '<div class="toast bootstrap-toast text-bg-' + tag + '" role="alert" aria-live="assertive" aria-atomic="true">' +
      '<div class="d-flex">' +
        '<div class="toast-body">' + message + '</div>' +
        '<button type="button" class="btn-close btn-close-white me-2" data-bs-dismiss="toast" aria-label="Close" style="margin: auto 1rem;"></button>' +
      '</div>' +
    '</div>';

  const block = document.querySelector('.bootstrap-toast-block');
  if (!block) return;
  block.insertAdjacentHTML('beforeend', toastHtml);
  const toastEl = block.lastElementChild;
  new bootstrap.Toast(toastEl).show();
};

// --- Generic API action buttons ---------------------------------------------
// <button data-action=api data-api-call=URL data-method=POST data-id=.. data-model=..
//         data-post-action=remove data-post-action-target=.selector>
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-action=api][data-api-call]');
  if (!btn) return;

  const postAction = btn.dataset.postAction;
  const postActionTarget = btn.dataset.postActionTarget;
  const method = (btn.dataset.method || 'GET').toUpperCase();
  const url = btn.dataset.apiCall;

  const payload = new URLSearchParams();
  if (btn.dataset.id) payload.append('id', btn.dataset.id);
  if (btn.dataset.model) payload.append('model', btn.dataset.model);

  const csrfEl = document.querySelector('[name="csrfmiddlewaretoken"]');
  const opts = {
    method: method,
    headers: { 'X-CSRFToken': csrfEl ? csrfEl.value : '' },
  };
  let fetchUrl = url;
  if (method === 'GET') {
    const qs = payload.toString();
    if (qs) fetchUrl += (url.indexOf('?') >= 0 ? '&' : '?') + qs;
  } else {
    opts.body = payload;
  }

  fetch(fetchUrl, opts)
    .then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        return { ok: r.ok, data: data };
      });
    })
    .then(function (res) {
      if (!res.ok) {
        window.showToast((res.data && res.data.message) || 'Une erreur est survenue.', 'danger');
        return;
      }
      if (res.data && res.data.message) {
        window.showToast(res.data.message, 'success');
      }
      // Kept for consumers listening on the button (e.g. prospects_list.js).
      // Data is carried in event.detail (CustomEvent), not a jQuery extra arg.
      btn.dispatchEvent(new CustomEvent('api:success', { bubbles: true, detail: res.data }));

      if (postAction && postActionTarget && postAction === 'remove') {
        const target = btn.closest(postActionTarget);
        if (target) target.remove();
      }
    })
    .catch(function () {
      window.showToast('Une erreur est survenue.', 'danger');
    });
});

// Facebook / LinkedIn share
document.addEventListener('click', function (e) {
  const btn = e.target.closest('button.facebook-share, button.linkedin-share');
  if (!btn) return;
  window.open(btn.dataset.url, 'article partagé', 'width=650, height=600');
});
